var Backbone = require('backbone');
var _ = require('lodash');
var $ = require('jquery');
var template = require('../templates/vote-detail.ejs');
var PubSub = require('tscom-pubsub');

module.exports = Backbone.View.extend({
    tagName: 'div',
    className: 'view-vote-detail',
    events: {
        'click .next-contestant': 'nextContestant',
        'click .prev-contestant': 'prevContestant',
        'click .vote': 'castVote',
        'mouseenter .button' : 'changeColor',
        'mouseleave .button' : 'changeColor'
    },
    /**
   *
   */
    initialize: function(options) {
        _.bindAll(this, 'render');

        this.model = options.model;
        this.cms = options.cms;
        this.auth = options.auth;
        this.connect = options.connect;
        this.collection = options.voteOption;
        this.router = options.router;
        console.log('detail view model', this.model);
    },
    /**
   *
   */
    nextContestant: function(e) {
        e.preventDefault();
        var model = this.collection.next(this.model);
        this.collection.setSelected(model.get('id'));
    },
    /**
   *
   */
    prevContestant: function(e) {
        e.preventDefault();
        var model = this.collection.prev(this.model);
        this.collection.setSelected(model.get('id'));
    },
    /**
   *
   */
    castVote: function(e) {
        e.preventDefault();

        // don't submit vote for inactive
        if (this.model.get('eliminated') == '1') {
            return;
        }

        if (!this.auth.get('isAuthorized')) {
            this.router.auth();
            this.listenToOnce(this.auth, 'change:isAuthorized', _.bind(this.castVote, this, e));
            return;
        }

        var evt = {
            target: this,
            name: 'eventClickVote',
            origEvent: e
        };

        this.trigger('trackEvent',evt);
        PubSub.trigger('cast-vote');

    },
    /**
   *
   */
    render: function() {

        this.$el.html(template(_.extend(this.model.toJSON(), {
            text: this.cms.get('text')['views_vote'],
            design: this.cms.get('text')['design'],
            model: this.collection.indexOf(this.model),
            length: this.collection.length
        })));

        //handle rendering the close button on IE 11
        var video = this.$el.find('iframe');
        var src = video.attr('src');
        video.attr('src', src + '?wmode=transparent');

        return this;
    },

    /**
   *
   */
    changeColor: function (e) {
        var $target = $(e.currentTarget).find('.vote');

        if($target.length === 0) {
            $target = $(e.currentTarget).find('.eliminated-vote');
            $target.toggleClass('hoverElim');
            return;
        }
    
        $target.toggleClass('hover');
    },

    renderedToDOM: function() {
        var videoContainer = this.$('.gallery');
        FB.XFBML.parse(videoContainer.get(0));
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/standard-vote/app/scripts/views/vote-detail.js
// module id = 236
// module chunks = 0